import React from "react";
// import { Spinner } from "@/components/ui/spinner";  // Use Tailwind or custom spinner

const Loading = () => {
  return (
    <div className="flex items-center justify-center h-[30vh]">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500 border-solid"></div>
    </div>
  );
};

export default Loading;
